import views from '@/views/';

export default [
  {
    component: views.clinicManagement.Info,
    label: '诊所信息',
    path: 'clinicInfo',
    name: 'clinicInfo',
  }, {
    component: views.clinicManagement.Personnel,
    label: '人员管理',
    path: 'personnel',
    name: 'personnel',
  }, {
    component: views.clinicManagement.addRole,
    label: '新增角色',
    path: 'addrole',
    name: 'addRole',
    menuHidden: true,
  }, {
    component: views.clinicManagement.Inspect,
    label: '检查治疗项设置',
    path: 'inspect',
    name: 'inspect',
  // }, {
  //   component: views.clinicManagement.RegistrationFee,
  //   label: '挂号费用设置',
  //   path: 'registrationFee',
  //   name: 'registrationFee',
  }, {
    component: views.clinicManagement.PerscriptionTemplate,
    label: '模板',
    path: 'perscriptionTemplate',
    name: 'perscriptionTemplate',
  }, {
    component: views.clinicManagement.templateDetail,
    label: '模板详情',
    path: 'templateDetail',
    name: 'templateDetail',
    menuHidden: true,
  }, {
    component: views.clinicManagement.PerscriptionTemplateAddCn,
    label: '模板添加饮片处方',
    path: 'perscriptionTemplateAddCn',
    name: 'perscriptionTemplateAddCn',
    menuHidden: true,
  }, {
    component: views.clinicManagement.PerscriptionTemplateAddCom,
    label: '模板添加成药处方',
    path: 'perscriptionTemplateAddCom',
    name: 'perscriptionTemplateAddCom',
    menuHidden: true,
  }, {
    component: views.clinicManagement.PerscriptionTemplateAddSti,
    label: '模板添加成药处方',
    path: 'perscriptionTemplateAddSti',
    name: 'perscriptionTemplateAddSti',
    menuHidden: true,
  }, {
    component: views.clinicManagement.PerscriptionTemplateAddInfusion,
    label: '模板添加成药处方',
    path: 'perscriptionTemplateAddInfusion',
    name: 'perscriptionTemplateAddInfusion',
    menuHidden: true,
  }, {
    component: views.clinicManagement.printSet,
    label: '打印设置',
    path: 'printSet',
    name: 'printSet',
  }, {
    component: views.clinicManagement.clinicSet,
    label: '诊所设置',
    path: 'clinicSet',
    name: 'clinicSet',
  },

];
